import { cn } from '@/lib/utils'

interface ProgressBarProps {
  value: number
  max?: number
  showLabel?: boolean
  size?: 'sm' | 'md'
  className?: string
}

export function ProgressBar({
  value,
  max = 100,
  showLabel = true,
  size = 'md',
  className,
}: ProgressBarProps) {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100)

  const getColorClass = (p: number): string => {
    if (p >= 80) return 'bg-[var(--progress-high)]'
    if (p >= 40) return 'bg-[var(--progress-medium)]'
    return 'bg-[var(--progress-low)]'
  }

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div
        className={cn(
          'flex-1 overflow-hidden rounded-full bg-[var(--progress-bg)]',
          size === 'sm' ? 'h-1' : 'h-1.5'
        )}
      >
        <div
          className={cn('h-full rounded-full transition-all', getColorClass(percentage))}
          style={{ width: `${String(percentage)}%` }}
        />
      </div>
      {showLabel && (
        <span className="text-muted-foreground text-[10px] font-bold whitespace-nowrap">
          {Math.round(value).toString()}/{max.toString()}
        </span>
      )}
    </div>
  )
}
